export const CLIENTE_VARIOS = 8;
